module.exports = __webpack_public_path__ + "media/images/review/ico-crown-4-46d500a27ff69871c86a2e9fb41b3d81.svg";